'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsBot = undefined;

var _reselect = require('reselect');

var _getBotResponder = require('conversations-schema/operators/widget-data/getBotResponder');

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

var getIsBot = exports.getIsBot = (0, _reselect.createSelector)(_getLatestWidgetData.getLatestWidgetData, function (widgetData) {
  return Boolean((0, _getBotResponder.getBotResponder)(widgetData));
});